<template>
    <div class="login">
        <div class="login__header"></div>
        <div class="login__content">
            <h1 class="login__title">Login</h1>
            <div class="login__card">
                <div class="md-layout-row md-layout-wrap md-gutter">
                    <div class="md-flex md-flex-small-100">
                        <div class="login__field">
                            <md-field md-inline>
                                <label>E-Mail</label>
                                <md-input v-model="username" type="text"></md-input>
                            </md-field>
                        </div>
                        <div class="login__field">
                            <md-field md-inline>
                                <label>Passwort</label>
                                <md-input v-model="password" type="password" @keyup.enter.native="login"></md-input>
                            </md-field>
                        </div>
                        <div class="login__button">
                            <button type="submit" class="button" @click="login">Anmelden</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <md-snackbar md-position="center" :md-duration="4000" :md-active.sync="showError" md-persistent>
            <span>Falsche Logindaten</span>
            <md-button class="md-primary" @click="showError = false">Schliessen</md-button>
        </md-snackbar>
    </div>
</template>

<script>
    // @ is an alias to /src
    import {mapGetters, mapActions} from 'vuex'
    import axios from 'axios'
    import store from 'store'

    export default {
        name: 'login',
        data() {
            return {
                username: '',
                password: '',
                showError: false
            }
        },
        computed: {
            ...mapGetters('auth', [
                'user',
            ])
        },
        methods: {
            ...mapActions('auth', [
                'authenticate'
            ]),
            login: async function () {
                try {
                    await this.authenticate({'username': this.username, 'password': this.password})
                    store.set('user', this.user)
                    console.log()
                    axios.defaults.headers.common['Authorization'] = `Bearer ${this.user.token}`;
                    this.$router.push('/')
                } catch (error) {
                    this.showError = true;
                }
            }
        }
    }
</script>